__turbopack_context__.v({
  "bg-standard": "timeline-slide-module-scss-module__nzRVtq__bg-standard",
  "bg-subtle": "timeline-slide-module-scss-module__nzRVtq__bg-subtle",
  "image": "timeline-slide-module-scss-module__nzRVtq__image",
  "placeholder": "timeline-slide-module-scss-module__nzRVtq__placeholder",
  "slide": "timeline-slide-module-scss-module__nzRVtq__slide",
  "timestamp": "timeline-slide-module-scss-module__nzRVtq__timestamp",
});
